<!-- 月度计划管理 -->
<template>
  <div>
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :beforeOpen="beforeOpen" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad" @selection-change="selectionChange">
      <template slot="menuLeft">
        <el-button icon="el-icon-add" type="primary" size="small" @click="handleAdd">新增</el-button>
        <!-- <el-button type="danger" icon="el-icon-delete" plain :disabled="selectionList.length == 0" @click="handleDelete">批量删除</el-button> -->
      </template>
      <template slot-scope="{row,index}" slot="menu">
        <el-button
         style="margin-left:20px;"
        icon="el-icon-delete"
        size="small"
        type="text"
        @click="showMore(row,index)">修改</el-button>
        <el-button
        v-if="row.planStatus == 3"
        style="margin-left:20px;"
        icon="el-icon-delete"
        size="small"
        type="text"
        @click="audit(row,index)">审核</el-button>
        <el-popconfirm v-if="row.planStatus == 1"  title="确定修订此条数据吗" @confirm="revise(row,index)">
        <el-button  size="small"
          style="margin-left:20px;"
        type="text" slot="reference">修订</el-button>
      </el-popconfirm>
        <el-button
          v-if="hasPermission('emergency_plan_screen_result')"
          type="text"
          size="small"
          icon="el-icon-view"
          @click="openScreenResult(row)"
        >查看摘取结果</el-button>
        <el-button
          v-if="hasPermission('emergency_plan_screen_preview')"
          type="text"
          size="small"
          icon="el-icon-document"
          @click="handleScreenPreview(row)"
        >原文预览</el-button>
      </template>

    </avue-crud>

    <!-- 子表内容：与「应急预案-新增界面」原型一致，多 Tab 整单提交 insert-detail / update-detail -->
    <dialog-reset slotShow height="78vh" top="4vh" width="88%" custom-class="y-plan-dialog" :title="planFormTitle" :visible.sync="formVisible">
      <WantMore ref="formComponen" :key="planFormKey" :is-edit="isEdit" :info-more="infoMore" />
      <span slot="dialog_footer">
      <el-button type="primary"
                 icon="el-icon-circle-plus-outline"
                 @click="submit">提 交</el-button>
    </span>
    </dialog-reset>
    <dialog-reset slotShow height="45vh" top="15vh" width="60%" title="审核" :visible.sync="auditFormVisible">
      <WantAudit ref="auditForm" v-if="auditFormVisible"></WantAudit>
      <span slot="dialog_footer">
      <el-button type="primary"
                 icon="el-icon-circle-plus-outline"
                 @click="auditSubmit">提 交</el-button>
                </span>
    </dialog-reset>

    <el-dialog
      title="大屏摘取结果"
      :visible.sync="screenResultVisible"
      width="86%"
      append-to-body
      custom-class="y-plan-screen-result-dialog"
    >
      <div v-loading="screenLoading">
        <el-alert
          v-if="screenResultForm.planId"
          type="info"
          :closable="false"
          show-icon
          class="screen-result-tip"
          :title="`当前预案：${screenCurrentPlan.planName || screenCurrentPlan.planCode || screenResultForm.planId}`"
        />
        <el-table
          :data="screenResultForm.contents"
          border
          size="small"
          height="420"
          empty-text="暂无摘取结果，请先上传并解析预案文件"
        >
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="sectionCode" label="区块编码" width="120" />
          <el-table-column prop="sectionTitle" label="区块标题" width="180">
            <template slot-scope="{ row }">
              <el-input
                v-model="row.sectionTitle"
                size="mini"
                :disabled="!hasPermission('emergency_plan_screen_save')"
              />
            </template>
          </el-table-column>
          <el-table-column prop="displayMode" label="展示方式" width="110">
            <template slot-scope="{ row }">
              <el-input
                v-model="row.displayMode"
                size="mini"
                :disabled="!hasPermission('emergency_plan_screen_save')"
              />
            </template>
          </el-table-column>
          <el-table-column prop="contentText" label="展示内容" min-width="280">
            <template slot-scope="{ row }">
              <el-input
                v-model="row.contentText"
                type="textarea"
                :rows="2"
                size="mini"
                :disabled="!hasPermission('emergency_plan_screen_save')"
              />
            </template>
          </el-table-column>
          <el-table-column prop="sourceText" label="原文依据" min-width="260" show-overflow-tooltip />
          <el-table-column prop="sortNo" label="排序" width="90">
            <template slot-scope="{ row }">
              <el-input-number
                v-model="row.sortNo"
                size="mini"
                :min="0"
                :controls="false"
                :disabled="!hasPermission('emergency_plan_screen_save')"
                class="screen-sort-input"
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer">
        <el-button size="small" @click="screenResultVisible = false">关 闭</el-button>
        <el-button
          v-if="hasPermission('emergency_plan_screen_save')"
          type="primary"
          size="small"
          :loading="screenLoading"
          @click="handleScreenSaveResult"
        >保存摘取结果</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="原文预览"
      :visible.sync="screenPreviewVisible"
      width="560px"
      append-to-body
    >
      <el-descriptions :column="1" border size="small">
        <el-descriptions-item label="文件名称">{{ screenPreviewFile.originalFileName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="文件类型">{{ screenPreviewFile.fileExt || '-' }}</el-descriptions-item>
        <el-descriptions-item label="文件大小">{{ formatScreenFileSize(screenPreviewFile.fileSize) }}</el-descriptions-item>
        <el-descriptions-item label="对象地址">{{ screenPreviewFile.previewObjectName || screenPreviewFile.objectName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="解析状态">{{ screenParseStatusText(screenPreviewFile.parseStatus) }}</el-descriptions-item>
        <el-descriptions-item label="解析信息">{{ screenPreviewFile.parseError || '-' }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer">
        <el-button size="small" @click="screenPreviewVisible = false">关 闭</el-button>
        <el-button
          type="primary"
          size="small"
          :disabled="!screenPreviewOpenUrl"
          @click="openScreenPreviewObject"
        >打开原文</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { mapGetters } from "vuex";
import {
  getList,
  add,
  update,
  remove,
  getDetail,
  selectDetail,
  audit,
  revise,
  parseScreenFile,
  getScreenExtractResult,
  saveScreenExtractResult,
  previewScreenFile,
  displayScreenResult
} from "./api";
import { getSearchTimeConfig,rulesInput } from "@/basic-common/util/common";
import matrixStatistics from '@/components/matrix/matrix-statistics'
import SelectContract from "./components/select-contract.vue";

import WantMore from './components/want-more.vue'
import WantAudit from './components/want-audit.vue'
export default {
  components: { matrixStatistics, SelectContract, WantMore,WantAudit,},
  mixins: [crudMixins],
  data () {
    const that = this
    return {
      isEdit:true,
      auditId:'',
      infoMore: {},
      form: {},
      auditFormVisible:false,
      formVisible:false,
      planFormKey: 0,
      screenLoading: false,
      screenResultVisible: false,
      screenPreviewVisible: false,
      screenResultForm: {
        planId: '',
        fileId: '',
        templateCode: 'default',
        publishStatus: 1,
        contents: []
      },
      screenCurrentPlan: {},
      screenPreviewFile: {},
      screenFileCache: {},

      apiConfig: { getList, add, update, remove, getDetail },
      option: {
        ...this.$store.state.publicOption,
        searchDateProp: false,
        submitBtn: false,
      emptyBtn: false,
      viewBtn:false,
      addBtn:false,
      editBtn:false,
      delBtn:true,
      menuWidth: 430,
        column: [
          {
            label: '预案编号',
            prop: 'planCode',
            overHidden: true, // 表格超出隐藏
            minWidth: 150,
            maxlength: 30,
            rules: rulesInput(1),
          },
          {
            label: '预案名称',
            prop: 'planName',
            overHidden: true, // 表格超出隐藏
            minWidth: 150,
            maxlength: 30,
            search: true,
            rules: rulesInput(1),
          },
          {
            label: '预案类型',
            prop: 'planType',
            search: true, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            width: 150,
            type: 'select',
            remote: true,
            hide: false,
            dicUrl: '/api/blade-system/dict/dictionary?code=yj-pla-type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: rulesInput(2),
          },
          // {
          //   label: '预案标签',
          //   prop: 'planType',
          //   overHidden: true, // 表格超出隐藏
          //   width: 150,
          //   type: 'input',
          //   maxlength: 50,
          //   placeholder: '请输入预案标签',
          // },
          {
            label: '预案状态',
            prop: 'planStatus',
            search: true, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            width: 150,
            type: "select",
            remote: true,
            hide: false,
            dicUrl: '/api/blade-system/dict/dictionary?code=yj-pla-status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: rulesInput(2),
          },
          {
            label: '修订时间',
            prop: 'revisionTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true, // 表格超出隐藏
            width: 180,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '录入时间',
            prop: 'issueTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true, // 表格超出隐藏
            width: 180,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '录入人员',
            prop: 'createUser',
            overHidden: true, // 表格超出隐藏
            width: 120,
            addDisplay: false,
            editDisplay: false,
          },

          {
            ...getSearchTimeConfig('', { type: 'datetimerange' }),
            searchValue: [],
            paramsKey: ["startTime", "endTime"],
          },
        ]
      },
      defaultParams: {  }
    }
  },
  computed: {
    ...mapGetters(["permission"]),
    planFormTitle () {
      return this.isEdit ? '编辑应急预案' : '新增应急预案'
    },
    screenPreviewOpenUrl () {
      const file = this.screenPreviewFile || {}
      return this.normalizePreviewUrl(file.previewObjectName || file.objectName)
    }
  },
  methods: {
    hasPermission(code) {
      return !!(this.permission && this.permission[code])
    },
    audit(row){
      this.auditFormVisible = true
      this.auditId = row.id
    },
    revise(row){
      revise({
          id:row.id
        }).then(({data}) =>{
          if(data.code === 200){
          this.$message.success(data.msg)
          this.onLoad(this.page)
        }
        })
    },
    auditSubmit(){
      if(this.$refs.auditForm){
        const data = this.$refs.auditForm.echoData()
        audit({
          ...data,
          id:this.auditId
        }).then(({data}) =>{
          if(data.code === 200){
          this.$message.success(data.msg)
          this.auditFormVisible = false
          this.onLoad(this.page)
        }
        })
      }
    },
    submit(){
      if(this.$refs.formComponen){
        const mixData = this.$refs.formComponen.echoData()
        if(this.isEdit){
          update({
            ...mixData,
          }).then(async ({data})=>{
            if(data.code === 200){
              const planId = this.resolveSavedPlanId(data, mixData)
              await this.handleAutoScreenParseAfterSave(planId, mixData)
              this.formVisible = false
              this.onLoad(this.page)
            }
          })
      }else{
        add({
          ...mixData,
        }).then(async ({data})=>{
          if(data.code === 200){
            const planId = this.resolveSavedPlanId(data, mixData)
            await this.handleAutoScreenParseAfterSave(planId, mixData)
            this.formVisible = false
            this.onLoad(this.page)
          }
        })
      }

      }


    },
    handleAdd(){
      this.infoMore = {}
      this.isEdit = false
      this.planFormKey += 1
      this.formVisible = true
    },
    showMore(row){
      this.isEdit = true
      selectDetail(row.id).then(({data})=>{
        this.infoMore = data.data || {}
        this.planFormKey += 1
        this.formVisible = true
      })

    },
    async handleAutoScreenParseAfterSave(planId, formData) {
      if (!planId) {
        this.$message.warning('保存成功，未获取到预案ID，未自动解析大屏内容')
        return
      }
      if (!this.hasPlanAttachment(formData && formData.planAttachment)) {
        this.$message.success('保存成功')
        return
      }
      this.$delete(this.screenFileCache, String(planId))
      try {
        const parseRes = await parseScreenFile({
          planId,
          templateCode: 'default',
          parserType: 'rule'
        })
        const task = this.unwrapData(parseRes) || {}
        if (Number(task.taskStatus) === 3) {
          this.$message.warning(task.errorMessage || '保存成功，自动解析大屏内容失败')
          return
        }
        this.$message.success('保存成功，已自动解析并同步大屏')
      } catch (e) {
        console.warn(e)
        this.$message.warning((e && e.message) || '保存成功，自动解析大屏内容失败')
      }
    },
    resolveSavedPlanId(data, formData) {
      const body = data && data.data
      if (body && typeof body === 'object') {
        return body.id || body.planId || (formData && formData.id)
      }
      return body || (formData && formData.id)
    },
    hasPlanAttachment(value) {
      if (Array.isArray(value)) {
        return value.length > 0
      }
      if (value === undefined || value === null) {
        return false
      }
      const text = String(value).trim()
      return !!text && !/^\[\s*\]$/.test(text)
    },
    async openScreenResult(row) {
      if (!row || !row.id) return
      this.screenLoading = true
      this.screenCurrentPlan = row
      this.screenResultVisible = true
      try {
        const screenFile = await this.resolveCurrentScreenFile(row, false)
        let result = await this.loadScreenExtractResult(row.id, screenFile)
        if ((!result.contents || result.contents.length === 0) && (screenFile || this.hasPlanAttachment(row.planAttachment))) {
          const task = await this.parseCurrentScreenFile(row.id)
          if (Number(task.taskStatus) === 3) {
            this.$message.warning(task.errorMessage || '自动解析大屏内容失败')
          } else {
            result = await this.loadScreenExtractResult(row.id, screenFile)
          }
        }
        this.assignScreenResultForm(row.id, screenFile, result)
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '查询摘取结果失败')
      } finally {
        this.screenLoading = false
      }
    },
    async loadScreenExtractResult(planId, screenFile) {
      const res = await getScreenExtractResult({
        planId,
        fileId: screenFile && screenFile.id,
        publishStatus: 1
      })
      return this.unwrapData(res) || {}
    },
    async parseCurrentScreenFile(planId) {
      const parseRes = await parseScreenFile({
        planId,
        templateCode: 'default',
        parserType: 'rule'
      })
      return this.unwrapData(parseRes) || {}
    },
    assignScreenResultForm(planId, screenFile, result) {
      this.screenResultForm = {
        planId,
        fileId: result.fileId || (screenFile && screenFile.id) || '',
        templateCode: result.templateCode || 'default',
        publishStatus: result.publishStatus == null ? 1 : result.publishStatus,
        contents: (result.contents || []).map(item => ({ ...item }))
      }
    },
    async handleScreenSaveResult() {
      if (!this.screenResultForm.planId) {
        this.$message.warning('请先选择预案')
        return
      }
      this.screenLoading = true
      try {
        await saveScreenExtractResult({
          ...this.screenResultForm,
          publishStatus: 1
        })
        this.$message.success('摘取结果已保存并同步大屏')
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '保存摘取结果失败')
      } finally {
        this.screenLoading = false
      }
    },
    async handleScreenPreview(row) {
      if (!row || !row.id) return
      this.screenLoading = true
      try {
        const screenFile = await this.resolveCurrentScreenFile(row)
        const res = await previewScreenFile({ planId: row.id })
        this.screenPreviewFile = this.unwrapData(res) || screenFile
        this.screenPreviewVisible = true
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '原文预览失败')
      } finally {
        this.screenLoading = false
      }
    },
    async resolveCurrentScreenFile(row, required = true) {
      const planId = row && row.id
      if (!planId) return null
      const cache = this.screenFileCache[String(planId)]
      if (cache && cache.id) return cache
      const res = await displayScreenResult({ planId })
      const display = this.unwrapData(res) || {}
      const file = display.file || {}
      if (file.id || file.previewObjectName || file.objectName) {
        this.$set(this.screenFileCache, String(planId), file)
        return file
      }
      if (required) {
        throw new Error('请先在编辑弹窗上传预案附件并保存')
      }
      return null
    },
    unwrapData(res) {
      const body = res && res.data
      if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
      return body
    },
    normalizePreviewUrl(value) {
      if (!value) return ''
      if (/^https?:\/\//i.test(value)) return value
      return ''
    },
    openScreenPreviewObject() {
      if (this.screenPreviewOpenUrl) {
        window.open(this.screenPreviewOpenUrl, '_blank')
      }
    },
    formatScreenFileSize(size) {
      if (!size) return '-'
      const num = Number(size)
      if (!Number.isFinite(num)) return size
      if (num < 1024 * 1024) return `${(num / 1024).toFixed(1)}KB`
      return `${(num / 1024 / 1024).toFixed(1)}MB`
    },
    screenParseStatusText(status) {
      const value = Number(status)
      if (value === 0) return '待解析'
      if (value === 1) return '解析中'
      if (value === 2) return '解析成功'
      if (value === 3) return '解析失败'
      return '-'
    },
    replace (row) {
      const replaceKey = ['id', 'custNo', 'contractEndTime', 'contractStartTime', 'cargoName', 'cargoNo', 'contractName', 'contractNo']
      replaceKey.forEach(item => {
        if (item != 'id') {
          this.$set(this.form, item, row[item])
        } else {
          this.$set(this.form, 'contractExtId', row['id'])
        }
      });
    }
  }
}
</script>
<style scoped lang="scss">
p {
  margin: 0;
}

.screen-result-tip {
  margin-bottom: 12px;
}

.screen-sort-input {
  width: 70px;
}
</style>
<style lang="scss">
.y-plan-dialog {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 16px 42px rgba(15, 23, 42, 0.18);

  .el-dialog__header {
    padding: 18px 28px;
    border-bottom: 1px solid #e8eef7;
    background: #fff;
  }

  .el-dialog__title,
  .centers span {
    font-size: 18px;
    font-weight: 600;
    color: #1f2d3d;
  }

  .el-dialog__body {
    padding: 16px 18px 0;
    background: #f4f7fb;
  }

  .el-dialog__footer {
    padding: 12px 24px;
    border-top: 1px solid #e8eef7;
    background: #fff;
    text-align: right;
  }

  .el-dialog__footer .el-button {
    min-width: 96px;
    border-radius: 4px;
  }
}
</style>
